export async function loadDeckData(deck) {
  const dataUrl = deck && deck.dataUrls ? deck.dataUrls.data : null;
  const cmUrl = deck && deck.dataUrls ? deck.dataUrls.countermeasures : null;
  const templateSequenceUrl = deck && deck.dataUrls ? deck.dataUrls.templateSequence : null;
  const pixelPresetsUrl = deck && deck.dataUrls ? deck.dataUrls.pixelPresets : null;

  console.log('[loadDeckData] urls', {
    dataUrl,
    cmUrl,
    templateSequenceUrl,
    pixelPresetsUrl
  });

  if (!dataUrl || !cmUrl) {
    throw new Error('Deck dataUrls not configured');
  }

  const fetchOptionalJson = async (url) => {
    if (!url) return null;
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  };

  const [rootRes, cmRes, templateSequenceJson, pixelPresetsJson] = await Promise.all([
    fetch(dataUrl),
    fetch(cmUrl),
    fetchOptionalJson(templateSequenceUrl),
    fetchOptionalJson(pixelPresetsUrl)
  ]);
  if (!rootRes.ok) throw new Error(`Failed to fetch ${dataUrl}: ${rootRes.status}`);
  if (!cmRes.ok) throw new Error(`Failed to fetch ${cmUrl}: ${cmRes.status}`);

  const [root, countermeasures] = await Promise.all([rootRes.json(), cmRes.json()]);

  const templateSequence =
    templateSequenceJson && Array.isArray(templateSequenceJson.templateSequence)
      ? templateSequenceJson.templateSequence
      : null;

  const pixelPresets = pixelPresetsJson && typeof pixelPresetsJson === 'object' ? pixelPresetsJson : null;

  return {
    root: root || {},
    countermeasures: Array.isArray(countermeasures) ? countermeasures : [],
    templateSequence,
    pixelPresets
  };
}
